export {
    default as DataInfo,
    IDataInfoProps,
} from './data-info';
